import React from 'react'

// nodejs library that concatenates classes
import classNames from 'classnames'
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'

// core components
import MyHeader from 'components/Header/MyHeader.js'
import MyFooter from 'components/Footer/MyFooter.js'
import Parallax from 'components/Parallax/Parallax.js'
import MyHeaderLinks from 'components/Header/MyHeaderLinks.js'

import styles from 'assets/jss/material-kit-react/views/contactPage.js'

// Sections for this page
import MapSection from './Sections/MapSection.js'
import ContactSection from './Sections/ContactSection.js'

const useStyles = makeStyles(styles)

export default function IndexPage(props) {
  const classes = useStyles()
  const { ...rest } = props

  return (
    <div>
      <MyHeader color="white" brand="江苏硕佰建筑科技有限公司" fixed rightLinks={<MyHeaderLinks />} {...rest} />
      <Parallax className={classes.parallax}>
        <MapSection />
      </Parallax>
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <ContactSection />
        </div>
      </div>
      <MyFooter />
    </div>
  )
}
